import React, { FormEvent, PropsWithChildren } from 'react';
import FormControl from 'react-bootstrap/FormControl';
import InputGroup from 'react-bootstrap/InputGroup';
import { Icon } from '../../features/icon/Icon';
import './Search.scss';
import classNames from 'classnames';

interface ISearchProps {
  onSearch: (value: string) => void;
  inverted?: boolean;
  placeholder?: string;
}

export function Search({ onSearch, inverted, placeholder }: PropsWithChildren<ISearchProps>): JSX.Element {
  const handleInput = (event: FormEvent<HTMLInputElement>): void => {
    const { value } = event.currentTarget;
    onSearch(value);
  };

  return (
    <InputGroup className={classNames('search search-group', inverted && 'search-group--inverted')}>
      <InputGroup.Prepend>
        <InputGroup.Text id="search-addon"><Icon icon="search"></Icon></InputGroup.Text>
      </InputGroup.Prepend>
      <FormControl
        aria-label="Zoeken..."
        aria-describedby="search-addon"
        onInput={handleInput}
        placeholder={placeholder}
      />
    </InputGroup>
  );
}
